module.exports = __webpack_public_path__ + "static/media/nptel.dfc2a5ce.jpg";